import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOnboardingReportDashboardComponent } from './fi-onboarding-report-dashboard.component';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FiReportWidgetModule } from '@fi-shared/fi-report-widget/fi-report-widget.module';
import { FiOnboardingReportSharedModule } from '../shared/fi-onboarding-report-shared.module';
import { FiRecentActivityWidgetContentComponent } from './fi-onboarding-report-widget/recent-activity-widget/widget-content/recent-activity-widget-content.component';
import { FiOnboardingReportWidgetComponent } from './fi-onboarding-report-widget/fi-onboarding-report-widget.component';
import { FiCommonOnboardingsWidgetComponent } from './fi-onboarding-report-widget/common-onboardings-widget/common-onboardings-widget.component';
import { FiRecentActivityWidgetComponent } from './fi-onboarding-report-widget/recent-activity-widget/recent-activity-widget.component';
import { FiTotalParticipantsOnboardedWidgetComponent } from './fi-onboarding-report-widget/total-participants-onboarded-widget/total-participants-onboarded-widget.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiTimeAgoPipeModule } from '@fi-shared/fi-time-ago-pipe/fi-time-age.module';
import { FiEmptyListModule } from '@fi-shared/fi-empty-list/fi-empty-list.module';
import { MatButtonModule } from '@angular/material/button';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';
import { FiOnboardingReportNewWidgetDialogComponent } from './fi-onboarding-report-new-widget-dialog/fi-onboarding-report-new-widget-dialog.component';
import { FiOnboardingReportNewWidgetDataFilterStepComponent } from './fi-onboarding-report-new-widget-dialog/new-widget-data-fitler-step/fi-onboarding-report-new-widget-data-filter-step.component';
import { FiOnbaordingReportNewWidgetFilterSettingsContentComponent } from './fi-onboarding-report-new-widget-dialog/new-widget-data-fitler-step/widget-filter-settings-content/fi-new-widget-filter-settings-content.component';
import { FiOnboardingReportDetailsModule } from '../fi-onboarding-report-details/fi-onboarding-report-details.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiRecentActivityWidgetDialogComponent } from './fi-onboarding-report-widget/recent-activity-widget/recent-activity-widget-dialog/recent-activity-widget-dialog.component';
import { FiItemsListFilterModule } from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter.module';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        DragDropModule,
        FiReportWidgetModule,
        FiOnboardingReportSharedModule,
        FiAppTextSharedModule,
        FiProfileIconModule,
        FiTimeAgoPipeModule,
        FiEmptyListModule,
        FiTooltipModule,
        FiOnboardingReportDetailsModule,
        FiLoadingModule,
        FiItemsListFilterModule,
        MatMenuModule,
        FormsModule,
    ],
    declarations: [
        FiOnboardingReportDashboardComponent,
        FiOnboardingReportWidgetComponent,
        FiCommonOnboardingsWidgetComponent,
        FiRecentActivityWidgetComponent,
        FiTotalParticipantsOnboardedWidgetComponent,
        FiRecentActivityWidgetContentComponent,
        FiOnboardingReportNewWidgetDialogComponent,
        FiOnboardingReportNewWidgetDataFilterStepComponent,
        FiOnbaordingReportNewWidgetFilterSettingsContentComponent,
        FiRecentActivityWidgetDialogComponent,
    ],
    exports: [FiOnboardingReportDashboardComponent],
})
export class FiOnboardingReportDashboardModule {}
